import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, TextField, Box, Button, Divider } from '@mui/material';
import QuestionnaireBuilder from './QuestionnaireBuilder';

const CreateQuestionnaire = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [previewMode, setPreviewMode] = useState(false);
    const [selectedQuestionnaireId, setSelectedQuestionnaireId] = useState(null);

    const togglePreviewMode = () => setPreviewMode((prev) => !prev);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h3" gutterBottom>
                Criar Novo Questionário
            </Typography>

            <Box sx={{ mb: 3 }}>
                <TextField
                    fullWidth
                    label="Título do Questionário"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    label="Descrição"
                    multiline
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </Box>

            <Divider sx={{ mb: 3 }} />

            <QuestionnaireBuilder
                title={title}
                description={description}
                db_data={[]}
                selectedQuestionnaireId={selectedQuestionnaireId}
                setSelectedQuestionnaireId={setSelectedQuestionnaireId}
                togglePreviewMode={togglePreviewMode}
                previewMode={previewMode}
            />
        </Box>
    );
};

export default CreateQuestionnaire;
